/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { setInfoFromFNOL, getClaimDamagePhotoTypes, handleNextStep, initiateGlassSteps, setClaimType, initiateFNOLSteps, setStep, startGlassClaim, setDefaultDispayTime, initiateDrivableSteps, initiateCellphoneSteps, initiateCellphoneOtherSteps, submitGeneralClaim, initiateWarrantyClaimSteps } from '../../../actions/claimSubmitActions';
import { isMobile } from 'react-device-detect';
import { FNOL_CLAIM_PROGRESS_MOBILE, SUBMIT_CLAIM, SUBMIT_CLAIM_DETAILS } from '../../../routes/routes';
import { navigateTo } from '../../../actions/navigationActions';
import './Glass.css';
import { CLAIM_TYPE_CELLPHONE, CLAIM_TYPE_GLASS, CLAIM_TYPE_VAP, CLAIM_TYPE_WARRANTY, SET_STEPS_CLAIMS_WARRANTY } from '../../../constants/constants';
import { BLING_LIKE_NEW_PRODUCT_ID, BLING_SCREEN_FIX_PRODUCT_ID, BLING_BRAND_NEW_PRODUCT_ID, CAR_CLAIM_VAPS_DINGS_AND_THINGS_ID, CAR_CLAIM_VAPS_SCRATCH_AND_DENT_ID, CAR_CLAIM_VAPS_TYRE_AND_RIM_ID } from '../../../constants/products';


class Disclaimer extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
        }
        this.handleIsDrivableYes = this.handleIsDrivableYes.bind(this);
        this.checkMobileRedirect = this.checkMobileRedirect.bind(this);
        this.handleNext = this.handleNext.bind(this);
    }

    async handleIsDrivableYes() {
        await this.props.handleSetFNOLDrivable(true);
        await this.props.dispatchHandleNextStep();
        this.checkMobileRedirect();
    }

    checkMobileRedirect() {
        if (isMobile && (this.props.claimSubmit.lastCompletedStep > (this.props.claimSubmit.selectedClaimStep.step))) {
            this.props.redirectTo(FNOL_CLAIM_PROGRESS_MOBILE);
            this.props.dispatchSetStep(this.props.claimSubmit.lastCompletedStep, this.props.claimSubmit.lastCompletedSubStep);
        }
    }

    async handleNext() {
        if (this.props.claimSubmit.selectedRiskItem.productName === 'Car warranty') {
            await this.props.dispatchSetDefaultDispayTime();
            await this.props.dispatchAction(setClaimType(CLAIM_TYPE_WARRANTY));
            await this.props.dispatchAction(initiateWarrantyClaimSteps());
        }
        else {
            var selectedDescription = this.props.claimSubmit.incidentType.description.toLowerCase();
            await this.props.dispatchSetDefaultDispayTime();
            if (this.props.claimSubmit.isCar) {
                await this.props.handleGetClaimDamagePhotoTypese(6);
            }
            else {
                await this.props.handleGetClaimDamagePhotoTypese(7);
            }
            if (selectedDescription === "windscreen/broken window (sunroof excluded)") { // glass claim
                await this.props.dispatchSetGlass(CLAIM_TYPE_GLASS);
                await this.props.dispatchInitiateGlassSteps();
                if (isMobile) {
                    this.props.redirectTo(FNOL_CLAIM_PROGRESS_MOBILE);
                }
                await this.props.dispatchHandleNextStep();
            }
            else if (this.props.claimSubmit.selectedRiskItem.product === BLING_LIKE_NEW_PRODUCT_ID || this.props.claimSubmit.selectedRiskItem.product === BLING_SCREEN_FIX_PRODUCT_ID || this.props.claimSubmit.selectedRiskItem.product === BLING_BRAND_NEW_PRODUCT_ID || (this.props.claimSubmit.selectedRiskItem.productName.toLowerCase() === "portable possessions" && this.props.claimSubmit.selectedRiskItem.riskItems[0].isCellphone)) {
                this.props.dispatchAction(setClaimType(CLAIM_TYPE_CELLPHONE));
                if (selectedDescription.toLowerCase() === "other") {
                    this.props.dispatchAction(initiateCellphoneOtherSteps());
                } else {
                    this.props.dispatchAction(initiateCellphoneSteps());
                }
                if (isMobile) {
                    this.props.redirectTo(FNOL_CLAIM_PROGRESS_MOBILE);
                }
                await this.props.dispatchHandleNextStep();

            } else if (this.props.claimSubmit.incidentType.id === CAR_CLAIM_VAPS_DINGS_AND_THINGS_ID || this.props.claimSubmit.incidentType.id === CAR_CLAIM_VAPS_SCRATCH_AND_DENT_ID || this.props.claimSubmit.incidentType.id === CAR_CLAIM_VAPS_TYRE_AND_RIM_ID) {
                await this.props.dispatchSetDefaultDispayTime();
                await this.props.dispatchAction(setClaimType(CLAIM_TYPE_VAP));
                await this.props.dispatchAction(initiateWarrantyClaimSteps());
            }
            else if ((selectedDescription !== "collision" && selectedDescription !== "windscreen/broken window (sunroof excluded)")
                || (selectedDescription === "collision" && (this.props.claimSubmit.selectedRiskItem.product === 9 || this.props.claimSubmit.selectedRiskItem.product === 13 || this.props.claimSubmit.selectedRiskItem.product === 5) && selectedDescription !== "windscreen/broken window (sunroof excluded)")) {

                await this.props.dispatchSetInfoFromFNOL(2, this.props.claimSubmit.selectedRiskItem, this.props.claimSubmit.incidentType)
                isMobile ? await this.props.redirectTo(SUBMIT_CLAIM_DETAILS) : await this.props.redirectTo(SUBMIT_CLAIM);
            }
            
            else {
                if (this.props.ssp.drivableClaimsEnabled) {
                    await this.props.dispatchInitiateDrivableSteps();
                } else {
                    await this.props.dispatchInitiateFNOLSteps();
                }
                await this.props.dispatchHandleNextStep();
            }
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    public render() {

        return (<div className="col ssp-container-fnol-disclaimer ssp-container-fnol-step-header-padding">
            <div className="row noma">
                <div className="col-12 nopa ssp-header-fnol-disclaimer">
                    <div className="row noma">
                        <div className="col nopa fnol-step-header-title-area">
                            <h3>Disclaimer</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row noma">
                <div className="col-12 fnol-steps-info-section-holder">
                    <hr className="hr-minus21px" />
                    <p className="font-size-15px noma mb-20px"><b>Due to the nature of our business, we record all your answers.</b></p>
                    <p className="font-size-15px noma">So, it’s super important to provide us with true and complete info. Incorrect and untruthful info could influence the outcome of your claim. <br /> <br /> By clicking on <b>‘I accept’</b> you acknowledge and agree to this.</p>
                    <button onClick={this.handleNext} className="btn btn-solid-red mt-40px font-size-14px button-width fnol-disclaimer-button">I accept</button>
                </div>
            </div>
        </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
        ssp: state.ssp
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchStartGlassClaim: () => dispatch(startGlassClaim()),
        dispatchSetInfoFromFNOL: (step, cover, event) => dispatch(setInfoFromFNOL(step, cover, event)),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        dispatchSetGlass: (typeOfClaim) => dispatch(setClaimType(typeOfClaim)),
        dispatchInitiateGlassSteps: () => dispatch(initiateGlassSteps()),
        dispatchInitiateDrivableSteps: () => dispatch(initiateDrivableSteps()),
        dispatchInitiateFNOLSteps: () => dispatch(initiateFNOLSteps()),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchSetDefaultDispayTime: () => dispatch(setDefaultDispayTime()),
        handleGetClaimDamagePhotoTypese: (productCode) => dispatch(getClaimDamagePhotoTypes(productCode)),
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Disclaimer)